module.exports = __webpack_public_path__ + "static/media/thunder.c6779920.svg";